import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { UseQueryOptions, useQuery } from 'react-query'
import { MediaFileProviderData } from 'types'

interface Data {
  provider: string
  provider_data: MediaFileProviderData
}

export const fetchMediaFileProviderData = async ({ key, signal }: { key: string; signal?: AbortSignal }) => {
  const res = await sendToApi<Data>(`/media_files/${key}/provider_data`, { signal })
  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }
  return res.data
}

export const useMediaFileProviderData = (key: string, options?: UseQueryOptions<Data>) => {
  return useQuery<Data>(['mediaFiles', 'providerData', key], () => fetchMediaFileProviderData({ key }), {
    cacheTime: Infinity,
    staleTime: Infinity,
    ...options,
  })
}
